import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../get-base-url';
import { useParams } from 'react-router-dom';
import ResearchCivilUnionNotificationShared from '../../research-notifications/research-civil-union';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchCivilUnionNotificationCivilStatusSharedProps {
  items?: BreadcrumbItem[];
  scope?: string;
}

const ResearchCivilUnionNotificationCivilStatusShared = ({
  items,
  scope,
}: ResearchCivilUnionNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/unione-civile/residenti/registrazione`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <ResearchCivilUnionNotificationShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchCivilUnionNotificationCivilStatusShared.displayName =
  'Research Civil Union Notifications Page component';

export default ResearchCivilUnionNotificationCivilStatusShared;
